import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import { CovidComponent } from './covid.component';
import { CovidMapComponent } from './covid-map/covid-map.component';
import { CovidSearchComponent } from './covid-search/covid-search.component';
import {LoaderModule} from "@shopping-angular-components/loader";

@NgModule({
    declarations: [CovidComponent, CovidMapComponent, CovidSearchComponent],
  imports: [
    CommonModule,
    LoaderModule
  ],
    exports: [
        CovidComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CovidModule { }
